document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.thb-quick-search');
  if (!trigger) return;

  const drawer = document.getElementById('Search-Drawer');
  if (!drawer) return;

  event.preventDefault();
  if (drawer.classList.contains('active')) return;
  document.body.classList.add('open-cc');
  drawer.classList.add('active');
  document.dispatchEvent(new CustomEvent('search:open'));
});
